// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  tableCell: {
    borderBottom: 'none',
    textAlign: 'left',
    'last-of-type': {
      color: 'blue',
      textAlign: 'right',
      width: '200px',
    },
    width: '300px',
    fontSize: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '250px',
  },
  iconTableCell: {
    borderBottom: 'none',
    textAlign: 'left',
    width: '30px',
    fontSize: '1em',
  },
  routerLink: {
    color: theme.palette.primary.main,
  },
  tooltip: {
    width: '250px',
    height: '200px',
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
    cursor: 'pointer',
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    marginRight: '100px',
    cursor: 'pointer',
  },
  divGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridColumnGap: theme.spacing(2),
    alignItems: 'center',
  },
  text: {
    fontSize: '12px',
    fontWeight: 400,
  },
  buttonProgress: {
    marginRight: '10px',
  },
  downloadText: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
});

export default styles;
